import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/quote")({
  head: () => ({
    meta: [
      { title: "Request a Quote | BAZZAR 3D" },
      {
        name: "description",
        content: "Tell us about your project and get a free quote within 24 hours from the BAZZAR 3D specialist team.",
      },
      { property: "og:title", content: "Request a Quote | BAZZAR 3D" },
      { property: "og:description", content: "Free quote within 24 hours for your project with BAZZAR 3D." },
    ],
  }),
  component: lazyRouteComponent(() => import("@/pages-lazy/quote")),
});